module.exports = __webpack_public_path__ + "src/app/assets/images/unicredit.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/unicredit.jpg
// module id = 641
// module chunks = 0